import React from 'react';
import { links } from '../data/site';
export function Contact() {
  return <section id="contact" data-id="element-25" data-mp="35858l10u4k73">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-20 md:py-28" data-id="element-26" data-mp="357vpzyi4dfbf">
        <div className="max-w-2xl" data-id="element-27" data-mp="316a79wiwm6tb">
          <h2 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-ink" data-id="element-28" data-mp="317cxs3cbe78p">
            What needs to move forward?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-29" data-mp="3sxq2geyj11v5">
            Tell me what’s happening, what you’re trying to accomplish, and where progress is
            getting difficult. We’ll use an initial 30-minute conversation to explore whether I can
            help.
          </p>
          <a href={links.booking} target="_blank" rel="noopener noreferrer" className="mt-9 inline-flex items-center justify-center text-base font-medium text-paper bg-ink px-7 py-3.5 rounded-md hover:bg-clay transition-colors duration-200" data-id="element-30" data-mp="3f6cm19vx0k4c">
            Book a Conversation
          </a>
        </div>
      </div>
    </section>;
}